export class CliError extends Error {}
export class ConfigError extends CliError {}
export class CompileError extends CliError {}

